import { render, staticRenderFns } from "./ModalDivider.vue?vue&type=template&id=6f0ca75e&scoped=true&"
import script from "./ModalDivider.vue?vue&type=script&lang=js&"
export * from "./ModalDivider.vue?vue&type=script&lang=js&"
import style0 from "./ModalDivider.vue?vue&type=style&index=0&id=6f0ca75e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0ca75e",
  null
  
)

export default component.exports